import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import LoadingSpinner from "../../../components/utils/LoadingSpinner";
import { Helmet } from "react-helmet-async";
import getDataById from "../../../hooks/admin/getDataById";
import ImageUploading from "react-images-uploading";
import { useTranslation } from "react-i18next";
import {
  Button,
  Card,
  Form,
  Input,
  Typography,
  Space,
} from "antd";

const { Title } = Typography;

const EditServices = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("admin"));
  const [images, setImages] = useState([]);
  const { id } = useParams();
  const [form] = Form.useForm();

  useEffect(() => {
    setLoading(true);
    const getServiceData = async () => {
      const res = await getDataById("admin/getbyidservice", id);
      if (res.status_code === 200) {
        form.setFieldsValue({
          title: res.data.title,
          description: res.data.description,
          url: res.data.url || "",
        });
      }
      setLoading(false);
    };
    getServiceData();
  }, [id, form]);

  const onChange = (imageList) => {
    setImages(imageList);
  };

  const handleUpdateService = async (values) => {
    setLoading(true);
    const userInfo = new FormData();

    if (images[0]?.file) {
      userInfo.append("image", images[0].file);
    }
    userInfo.append("id", id);
    userInfo.append("title", values.title);
    userInfo.append("description", values.description);
    if (values.url) {
      userInfo.append("url", values.url);
    }

    fetch(`${process.env.REACT_APP_APIURL}/admin/updateservice`, {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
      body: userInfo,
    })
      .then((res) => res.json())
      .then((info) => {
        setLoading(false);
        if (info.status_code === 200) {
          toast.success(`${t("update_Service_success")}`);
          window.history.go(-1);
        } else {
          toast.error(info?.message || info?.err);
        }
      });
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className="container mx-auto p-4">
      <Helmet>
        <title>{t("Admin")} - {t("Edit_Service")}</title>
      </Helmet>

      <div className="flex justify-between items-center mb-4">
        <Title level={4}>{t("Edit_Service")}</Title>
        <Link to="/admin/settings/general_services">
          <button className="btn btn-primary btn-sm text-white">{t("Back_Service")}</button>
        </Link>
      </div>

      <Card>
        <Form
          layout="vertical"
          form={form}
          onFinish={handleUpdateService}
        >
          <Form.Item
            label={
              <>
                {t("Service_Title")} <span className="text-red-600">*</span>
              </>
            }
            name="title"
            rules={[{ required: true, message: t("Service_Title_req") }]}
          >
            <Input placeholder={t("Service_Title")} />
          </Form.Item>

          <Form.Item
            label={t("Service_Image")}
          >
            <ImageUploading
              value={images}
              onChange={onChange}
              dataURLKey="data_url"
            >
              {({
                imageList,
                onImageUpload,
                onImageRemove,
                isDragging,
                dragProps,
              }) => (
                <div className="upload__image-wrapper">
                  <Button
                    onClick={onImageUpload}
                    {...dragProps}
                    style={{ marginBottom: 10 }}
                  >
                    {t("add_new_product_T_img_info")}
                  </Button>
                  <Space>
                    {imageList.map((image, index) => (
                      <div key={index} style={{ position: "relative" }}>
                        <img
                          src={image["data_url"]}
                          alt=""
                          style={{ width: "80px", height: "80px", objectFit: "cover" }}
                        />
                        <Button
                          danger
                          size="small"
                          onClick={() => onImageRemove(index)}
                          style={{ position: "absolute", top: 0, right: 0 }}
                        >
                          X
                        </Button>
                      </div>
                    ))}
                  </Space>
                </div>
              )}
            </ImageUploading>
          </Form.Item>

          <Form.Item
            label={
              <>
                {t("Services_Description")} <span className="text-red-600">*</span>
              </>
            }
            name="description"
            rules={[{ required: true, message: t("Services_Description_req") }]}
          >
            <Input placeholder={t("Services_Description")} />
          </Form.Item>

          <Form.Item
            label={t("Url")}
            name="url"
          >
            <Input placeholder={t("Url")} />
          </Form.Item>

          <Form.Item>
            <button
              type="submit"
              className="btn btn-primary btn-sm text-white"
            >
              {t("Service_Update")}
            </button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default EditServices;
